import { createAPIMethod, type Pagination } from 'utils/generic.ts';
import {
	normalizeSearchSearchUnpackedOffer,
	normalizeUnpackedOffer,
	type RemoteUnpackedOfferData,
	type UnpackedOfferData,
} from 'service/unpacked/model.ts';
import {
	normalizeOfferCategoryData,
	type ResponseOfferCategoryData,
	type OfferCategoryData,
} from 'service/category/model.ts';
import type { GetOffersParams } from 'service/offer/resource';

export type SearchUnpackedOffersParams = Pick<
	GetOffersParams,
	'category_id' | 'price_to' | 'price_from' | 'limit' | 'offset' | 'phrase'
> & {
	sort?: 'zbozi' | 'priceAsc' | 'priceDesc';
	shop_id?: number | string;
	include_leaf_categories?: boolean;
};
export type SearchUnpackedOffersResponse = {
	results: UnpackedOfferData[];
	pagination: Pagination;
	categories: OfferCategoryData[];
	leaf_categories: OfferCategoryData[];
};

export async function searchUnpackedOffers(
	params: SearchUnpackedOffersParams,
	headers?: HeadersInit,
	abortController?: AbortController,
) {
	return createAPIMethod<SearchUnpackedOffersParams, SearchUnpackedOffersResponse>({
		method: 'GET',
		path: '/zbozi/unpacked/search',
		normalize: ({ results, pagination, categories, leaf_categories }) => ({
			categories: categories.map((category: ResponseOfferCategoryData) => normalizeOfferCategoryData(category)),
			leaf_categories:
				leaf_categories?.map((category: ResponseOfferCategoryData) => normalizeOfferCategoryData(category)) ??
				[],
			results: results.map((offer: RemoteUnpackedOfferData) => normalizeSearchSearchUnpackedOffer(offer)),
			pagination,
		}),
		headers,
		abortController,
		useCache: true,
	})(params);
}

export type GetUnpackedOffersDetailParams = { id: string };
export type GetUnpackedOffersDetailResponse = UnpackedOfferData;

export async function getUnpackedOfferDetail(params: GetUnpackedOffersDetailParams, headers?: HeadersInit) {
	return createAPIMethod<GetUnpackedOffersDetailParams, GetUnpackedOffersDetailResponse>({
		method: 'GET',
		path: `/zbozi/unpacked/detail/${params.id}`,
		normalize: ({ result }) => normalizeUnpackedOffer(result as RemoteUnpackedOfferData),
		headers,
		useCache: false, // The request returns impression data, that needs to be different for each request
	})();
}
